// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tmmhqtkkmoivcgjolyjp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRtbWhxdGtrbW9pdmNnam9seWpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY0NDk0MjEsImV4cCI6MjA1MjAyNTQyMX0.xSUsWety5H21AXQ9uu7syvupVnFsQ30_uSyNNQV-WqA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);